function _s(o, i, p, l) {
    void 0 === i && (i = 400),
        void 0 === l && (l = !1),
        (o.style.overflow = "hidden"),
        l && (o.style.display = "block");
    var n,
        t = window.getComputedStyle(o),
        s = parseFloat(t.getPropertyValue("height")),
        a = parseFloat(t.getPropertyValue("padding-top")),
        r = parseFloat(t.getPropertyValue("padding-bottom")),
        y = parseFloat(t.getPropertyValue("margin-top")),
        d = parseFloat(t.getPropertyValue("margin-bottom")),
        g = s / i,
        m = a / i,
        h = r / i,
        u = y / i,
        x = d / i;
    window.requestAnimationFrame(function t(e) {
        void 0 === n && (n = e);
        e -= n;
        l
            ? ((o.style.height = g * e + "px"),
                (o.style.paddingTop = m * e + "px"),
                (o.style.paddingBottom = h * e + "px"),
                (o.style.marginTop = u * e + "px"),
                (o.style.marginBottom = x * e + "px"))
            : ((o.style.height = s - g * e + "px"),
                (o.style.paddingTop = a - m * e + "px"),
                (o.style.paddingBottom = r - h * e + "px"),
                (o.style.marginTop = y - u * e + "px"),
                (o.style.marginBottom = d - x * e + "px")),
            i <= e
                ? ((o.style.height = ""),
                    (o.style.paddingTop = ""),
                    (o.style.paddingBottom = ""),
                    (o.style.marginTop = ""),
                    (o.style.marginBottom = ""),
                    (o.style.overflow = ""),
                    l || (o.style.display = "none"),
                    "function" == typeof p && p())
                : window.requestAnimationFrame(t);
    });
}
(HTMLElement.prototype.slideToggle = function (t, e) {
    0 === this.clientHeight ? _s(this, t, e, !0) : _s(this, t, e);
}),
    (HTMLElement.prototype.slideUp = function (t, e) {
        _s(this, t, e);
    }),
    (HTMLElement.prototype.slideDown = function (t, e) {
        _s(this, t, e, !0);
    });


class Headerjs extends HTMLElement {
    constructor() {
        super();
    }

    connectedCallback() {
        this.querySelectorAll('[open-menu]').forEach((burger) => {
            burger.addEventListener('click', () => {
                this.classList.toggle('drawer-open');
                this.querySelector('.header__drawer').classList.toggle('is-open');

                document.body.classList.add('overflow-hidden');

            });
        });

        // set --footer-height variable 
        const footerHeight = document.querySelector('.footer').offsetHeight;
        document.documentElement.style.setProperty('--footer-height', footerHeight + 'px');

        window.addEventListener('resize', () => {
            const footerHeight = document.querySelector('.footer').offsetHeight;
            document.documentElement.style.setProperty('--footer-height', footerHeight + 'px');
        });

        //  init --vh variable 
        const vh = window.innerHeight * 0.01;
        document.documentElement.style.setProperty('--vh', `${vh}px`);

        window.addEventListener('resize', () => {
            const vh = window.innerHeight * 0.01;
            document.documentElement.style.setProperty('--vh', `${vh}px`);
        });



        // set --header-height variable 
        const headerHeight = document.querySelector('.header').offsetHeight;
        document.documentElement.style.setProperty('--header-height', headerHeight + 'px');
        window.addEventListener('resize', () => {
            const headerHeight = document.querySelector('.header').offsetHeight;
            document.documentElement.style.setProperty('--header-height', headerHeight + 'px');
        });


        this.querySelectorAll('[data-handle-link]').forEach((link) => {
            link.addEventListener('click', (e) => {
                this.setDropdownLink(e.currentTarget);
            });
        });

        document.querySelector('.header__nav-dropdown-overlay').addEventListener('click', () => {
            this.closeDropdown();
        });


        this.querySelectorAll(".faq-item-title").forEach((button) => {
            button.addEventListener("click", this.toggleFaqItem.bind(this));
        });


        this.querySelectorAll('[close-menu]').forEach((close) => {
            close.addEventListener('click', () => {
                this.classList.remove('drawer-open');
                this.querySelector('.header__drawer').classList.remove('is-open');
                document.body.classList.remove('overflow-hidden');
            });
        });
    }

    setDropdownLink(link) {
        if (link.classList.contains('is-open')) {
            this.closeDropdown();
        } else {
            link.classList.add('is-open');
            let heightDropdown = link.querySelector('.header__nav-dropdown').offsetHeight + 20;
            document.querySelector('.header__nav-dropdown-back').style.height = heightDropdown + 'px';
            document.body.classList.add('overflow-hidden');
        }
    }

    closeDropdown() {
        this.querySelectorAll('.header__nav-link').forEach((link) => {
            link.classList.remove('is-open');
        });
        document.querySelector('.header__nav-dropdown-back').style.height = '0px';
        document.body.classList.remove('overflow-hidden');

        document.querySelectorAll('.product-card__add').forEach((el) => {

            const addContainer = el;
            let priceElement = addContainer.querySelector('.product-card__add-price');
            let topElement = addContainer.querySelector('.product-card__add-top');
            let button = addContainer.querySelector('[add-to-cart]');

            // Collapse animation
            topElement.classList.add('product-card__add-top--hidden');
            topElement.classList.remove('product-card__add-top--visible');

            setTimeout(() => {
                priceElement.classList.remove('product-card__add-price--visible');
                button.classList.remove('expanded');
            }, 300); // Match CSS transition duration
        });
    }

    toggleFaqItem(e) {
        e.currentTarget
            .querySelector(".faq-close")
            .classList.toggle("faq-display-none");

        e.currentTarget.parentNode.classList.toggle("faq-item-active");

        const item = e.currentTarget.parentNode.querySelector(".faq-item-text");
        console.log(item);

        item.slideToggle("250");
    }
}

customElements.define('header-js', Headerjs);